<!-- Enrollment header -->
<template>
	<div class="provider">
		<h1>
			<div class="icon">
				<AddUserIcon></AddUserIcon>
			</div>
			Enroll Patients
		</h1>
		<h2>
			<el-button 
				type="primary"
				@click="$router.push({path: '/import'})"
				class="upload-button">
				<UploadIcon></UploadIcon>
				&nbsp;
				Upload Excel or CSV File
			</el-button>
			OR
		</h2>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AddUserIcon from '../icons/AddUser'
import UploadIcon from '../icons/Upload'

export default {
	name: 'add-provider-profile',
	props: {
		provider: {
			type: Object,
			required: true
		},
		profiles: {
			type: Array,
			required: true
		}
	},

	watch: {
		profiles: {
			handler(val) {
				if(Array.isArray(this.profiles) && this.profiles.length === 1) {
					this.currentProfileId = this.profiles[0].id
					this.setProfile(this.currentProfileId)
				}
			},
			immediate: true
		}
	},

	data() {
		return {
			currentProfileId: null
		}
	},

	methods: {
		setProfile(profileId) {
			if(profileId) {
				let profile = this.profiles.find((profile) => profile.id === profileId)
				this.$emit('profile', profile)
			}
		}
	},

	computed: {
		...mapState('provider', [
			'loadedAllProviders'
		]),
	},

	components: {
		AddUserIcon,
		UploadIcon
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
